"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.traitsMatchSegmentCondition = exports.evaluateIdentityInSegment = exports.getIdentitySegments = void 0;
var hashing_1 = require("../utils/hashing");
var constants_1 = require("./constants");
function getIdentitySegments(environment, identity, overrideTraits) {
    return environment.project.segments.filter(function (segment) {
        return evaluateIdentityInSegment(identity, segment, overrideTraits);
    });
}
exports.getIdentitySegments = getIdentitySegments;
function evaluateIdentityInSegment(identity, segment, overrideTraits) {
    return (segment.rules.length > 0 &&
        segment.rules.filter(function (rule) {
            return traitsMatchSegmentRule(overrideTraits || identity.identityTraits, rule, segment.id, identity.djangoID || identity.compositeKey);
        }).length === segment.rules.length);
}
exports.evaluateIdentityInSegment = evaluateIdentityInSegment;
function traitsMatchSegmentRule(identityTraits, rule, segmentId, identityId) {
    var matchesConditions = rule.conditions.length > 0
        ? rule.matchingFunction()(rule.conditions.map(function (condition) {
            return traitsMatchSegmentCondition(identityTraits, condition, segmentId, identityId);
        }))
        : true;
    return (matchesConditions &&
        rule.rules.filter(function (rule) {
            return traitsMatchSegmentRule(identityTraits, rule, segmentId, identityId);
        }).length === rule.rules.length);
}
function traitsMatchSegmentCondition(identityTraits, condition, segmentId, identityId) {
    if (condition.operator == constants_1.PERCENTAGE_SPLIT) {
        var hashedPercentage = (0, hashing_1.getHashedPercentateForObjIds)([segmentId, identityId]);
        return hashedPercentage <= parseFloat(String(condition.value));
    }
    var traits = identityTraits.filter(function (t) { return t.traitKey === condition.property_; });
    var trait = traits.length > 0 ? traits[0] : undefined;
    if (condition.operator === constants_1.IS_SET) {
        return !!trait;
    }
    else if (condition.operator === constants_1.IS_NOT_SET) {
        return trait == undefined;
    }
    return trait ? condition.matchesTraitValue(trait.traitValue) : false;
}
exports.traitsMatchSegmentCondition = traitsMatchSegmentCondition;
